import React, { useContext } from 'react'
import { IconButton, useMediaQuery, useTheme } from '@mui/material'
import Image from 'next/image'
import MenuIcon from '@mui/icons-material/Menu'

import Logo from './Logo'
import NotConnectedButtons from './NotConnectedButtons'
import ProfileContext from '@/components/Context/ProfileContext'
import AeliaLogoSecondImg from '../../../public/images/groupement/aelia/logo_aelia_second.png'
import FrancoProgress from '@/components/Common/Header/FrancoProgress'
import AeliaStoreBandeau from './AeliaStoreBandeau'

import IconMenu from './IconMenu'
import Search from './Search'

type HeaderTopProps = {
  isInMaintenance: boolean
  onMenuClick?: (e: any) => void
}

const HeaderTop: React.FC<HeaderTopProps> = ({ isInMaintenance, onMenuClick }) => {
  const { profile, isAuthenticated } = useContext(ProfileContext)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div>
      <AeliaStoreBandeau />
      <div className="mt-2 mb-2 md:mb-2 flex justify-between items-center md:px-8">
        <div className="flex items-center">
          <div className="md:hidden">
            {isAuthenticated && (
              <IconButton onClick={onMenuClick} style={{ color: theme.palette.text.primary }}>
                <MenuIcon />
              </IconButton>
            )}
          </div>

          <Logo />
        </div>

        {!!isAuthenticated && !isMobile && (
          <div className="w-6/12">
            <Search />
          </div>
        )}

        {/* Section droite - Mobile: Icônes, Desktop: Icônes + Nom utilisateur */}
        {!isInMaintenance && (
          <div className="flex flex-row justify-end items-center gap-1 sm:gap-4">
            {!!profile.groupAeliaStore && (
              <Image
                src={AeliaLogoSecondImg}
                alt="Aelia"
                width={150}
                height={50}
                className="hidden md:block"
              />
            )}

            {isAuthenticated && !profile.groupSubscriptionActive && <FrancoProgress />}

            {isAuthenticated ? (
              <IconMenu authenticate={isAuthenticated} />
            ) : (
              <NotConnectedButtons />
            )}
          </div>
        )}
      </div>

      {!!isAuthenticated && !!isMobile && (
        <div className="w-full px-2">
          <Search />
        </div>
      )}
    </div>
  )
}

export default HeaderTop
